<template>
  <span class="tabular-nums">
    {{ formatted }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  value: number | null | undefined;
}>();

const formatter = new Intl.NumberFormat(undefined, {
  style: "percent",
});

const formatted = computed(() => {
  const value = props.value;
  if (value === undefined || value === null || Number.isNaN(value)) {
    return `—`;
  }

  if (value > 0 && value < 0.005) {
    return "<1%";
  }
  if (value < 1 && value >= 0.995) {
    return ">99%";
  }

  return formatter.format(value);
});
</script>
